import { CaregiverRoleEnum } from '@/shared/enums';
import { fetch } from '@/shared/fetch';

import { ICaregiverConsultationDto } from '@/caregiverSpace/shared/model';

export const fetchWaitingRoomVideoConsultations = (
    role?: CaregiverRoleEnum | null,
): Promise<ICaregiverConsultationDto[]> => {
    const url =
        role != null
            ? `/api/caregiverspace/waiting-room/video?role=${role}`
            : '/api/caregiverspace/waiting-room/video';
    return fetch(url, 'GET');
};
